console.log('development');

// use a script tag or an external JS file
document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)
    // gsap code here!


    const merits = document.querySelectorAll('.merit_img');
    const subImg = document.querySelectorAll('.merit_sub_img');
    const infos = document.querySelectorAll('.info_img');

    if (window.matchMedia('(min-width: 769px)').matches) {
        merits.forEach((merit) => {

            gsap.set(merit, {
                y: 50,
            });


            gsap.to(merit, {
                y: -50,
                scrollTrigger: {
                    trigger: merit,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });


            if (subImg) {
                gsap.fromTo(subImg, {
                    y: 30
                }, {
                    y: 0,
                    scrollTrigger: {
                        trigger: merits[3],
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 1.5
                    }
                });
            }
        });

        gsap.set('.point_img', {
            y: 130
        })
        gsap.to('.point_img', {
            y: -130,
            scrollTrigger: {
                trigger: merits[0],
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    gsap.set(infos[1], {
        y: 30,
    })

    gsap.to(infos[1], {
        y: -30,
        scrollTrigger: {
            trigger: infos[1],
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
        }
    })


    if (window.matchMedia('(max-width: 769px)').matches) {
        window.addEventListener('scroll', () => {
            for (let i = 0; i < merits.length; i++) {
                const rect = merits[i].getBoundingClientRect().top;
                const scroll = window.scrollY || document.documentElement.scrollTop;
                const offset = rect + scroll;
                const windowHeight = window.innerHeight; // 現在のブラウザの高さ
                if (scroll > offset - windowHeight + 100) {
                    merits[i].classList.add('active');
                } else {
                    merits[i].classList.remove('active');
                }
            }
        });
    }

});